// src/firebase/config.js
// 🔥 IMPORTANT: Replace the values below with your actual Firebase project config.
// How to get your config:
//   1. Go to https://console.firebase.google.com
//   2. Create a new project (or use existing)
//   3. Go to Project Settings → General → Your apps → Add app (Web)
//   4. Copy the firebaseConfig object and paste it here
//   5. Enable Firestore Database in the Firebase console (Build → Firestore Database)
//   6. Set Firestore rules to allow read (public) and write (authenticated only)

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDn3vvwLTEPKT0UqVWQJitiXsiOJACUzGE",
  authDomain: "sunaharco-app.firebaseapp.com",
  projectId: "sunaharco-app",
  storageBucket: "sunaharco-app.firebasestorage.app",
  messagingSenderId: "937009999754",
  appId: "1:937009999754:web:bfaf887379335b6f7ea273",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
